import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModemChoiceService } from './modem-choice.service';
import { Line } from './models/line.model';
import { Ont } from './models/ont.model';
import { Vlan } from './models/vlan.model';

@UntilDestroy()
@Component({
  selector: 'mprd-modem-choice',
  templateUrl: './modem-choice.component.html',
})
export class ModemChoiceComponent implements OnInit {
  line: Line | undefined;
  selectedNcName = '';
  selectedSubscriberNumber = '';
  addOntModalOpen = false;
  editOntModalOpen = false;
  deleteOntModalOpen = false;
  voipCredentialsModalOpen = false;
  voipSubscriberNumbers$!: Observable<string[]>;

  constructor(
    private route: ActivatedRoute,
    private modemChoiceService: ModemChoiceService,
  ) {}

  ngOnInit(): void {
    const circuitId = this.route.snapshot.params.circuitId;
    this.modemChoiceService
      .fetchLine(circuitId)
      .pipe(
        tap((line) => (this.line = line)),
        untilDestroyed(this),
      )
      .subscribe();

    this.voipSubscriberNumbers$ =
      this.modemChoiceService.fetchVoipSubscriberNumbers();
  }

  onAddOntModalOpened(): void {
    this.addOntModalOpen = true;
  }

  onEditOntModalOpened({ ncName }: { ncName: string }): void {
    this.selectedNcName = ncName;
    this.editOntModalOpen = true;
  }

  onDeleteOntModalOpened({ ncName }: { ncName: string }): void {
    this.selectedNcName = ncName;
    this.deleteOntModalOpen = true;
  }

  onVoipCredentialsModalOpened({
    subscriberNumber,
  }: {
    subscriberNumber: string;
  }): void {
    this.selectedSubscriberNumber = subscriberNumber;
    this.voipCredentialsModalOpen = true;
  }

  onAddedOnt(ont: Ont): void {
    this.line.devices.push(ont);
  }

  onEditedOnt(ont: Ont): void {
    const index = this.line.devices.findIndex(
      (device) => device.ncName === ont.ncName,
    );
    this.line.devices[index] = ont;
  }

  onDeletedOnt(ont: Ont): void {
    if (ont.active) {
      const companyOnt = this.line.devices.find(
        (device) => device.providedBy === 'COMPANY',
      );
      companyOnt.active = true;
    }
    const index = this.line.devices.findIndex(
      (device) => device.ncName === ont.ncName,
    );
    this.line.devices.splice(index, 1);
  }

  onUpdatedVlan(vlan: Vlan): void {
    this.line.vlanMode = vlan;
  }
}
